import { ConfigurationError } from "@tmi/types/errors";

/*
 * TODO: if this ever gets to the point where we need to support additional "cultures" - this is the pattern
 *
 * const englishUsCultureKey = 'en-US';
 * cont labelByCultureMap: ReadonlyMap< string, ReadonlyMap< string, string > > =
 *      new Map< string, ReadonlyMap< string, string > >( [
 *          [ englishUsCultureKey, new Map< string, string >( [
 *                  [ 'lblXXX', 'XXX' ],
 *                  ...
 *              ]
 *          ]
 *      ] );
 *
 * label( key: string, culture?: string = englishUsCultureKey ): string {
 *     const labelValue #labelByCultureMap.get( culture ).get( key );
 *      if ( !labelValue ) {
 *          throw new ConfigurationError(
 *              `The label key '${ key }' is not currently defined. Update the configuration and rebuild.`
 *          );
 *      }
 *
 *      return labelValue;
 *  }
 */

// TODO: use a service or global json file that can be edited within a tool that makes this more manageable
const labelMap: ReadonlyMap< string, string > = new Map( [
    [ 'lblAlliance', 'Alliance' ],
    [ 'lblDashboard', 'Dashboard' ],
    [ 'lblHome', 'Home' ],
    [ 'lblServices', 'Services' ],
    [ 'lblMarketAlerts', 'Alerts' ],
    [ 'lblSectorAlerts', 'Sector Alerts' ],
    [ 'lblTradeAlerts', 'Trade Alerts' ],
    [ 'lblLearning', 'Learning' ],
    [ 'lblContent', 'Content' ],
    [ 'lblArticles', 'Articles' ],
    [ 'lblBonusReports', 'Bonus Reports' ],
    [ 'lblCourses', 'Courses' ],
    [ 'lblSectorEdge', 'Sector Edge' ],
    [ 'lblWebinars', 'Webinars' ],
    [ 'lblTools', 'Tools' ],
    // nav-11: the Tools panel's sub-group headings
    [ 'lblToolsSectorsEtfs', 'Sectors & ETFs' ],
    [ 'lblToolsBreadth', 'Breadth' ],
    [ 'lblToolsCalculators', 'Calculators' ],
    [ 'lblSectorBpis', 'Sector BPIs' ],
    [ 'lblEtfListing', 'ETF Listing by Sector' ],
    [ 'lblMajorIndexBreadth', 'Major Index Charts' ],
    [ 'lblNyseBpi', 'NYSE BPI' ],
    [ 'lblPortfolioBuilder', 'Portfolio Builder' ],
    [ 'lblPositionSizeCalculator', 'Position Size Calculator' ],
    [ 'lblStockReplacementStrategyCalculator', 'Stock Replacement Calculator' ],
    [ 'lblRsProxy', 'URGENCY' ],
    [ 'lblRsMatrix', 'Urgency Tracker' ],
    [ 'lblSectorRelativeRankingTitle', 'URGENCY Ranking (45 sectors)' ],
    [ 'lblSectorRsRankTitle', 'URGENCY Rank' ],
    [ 'lblSector', 'Sector' ],
    [ 'lblSectors', 'Sectors' ],
    [ 'lblBpiProxy', 'Sector Demand' ],
    [ 'lblSectorTree', 'Sector Tree' ],
    [ 'lblSpreadCalculators', 'Spread Calculators' ],
    [ 'lblSpreadAnalyzer', 'Spread Analyzer' ],
    [ 'lblMyAccount', 'My Account' ],
    [ 'lblOptionsCalculator', 'Options Calculator' ],
    [ 'lblProfile', 'Profile' ],
    [ 'lblBilling', 'Billing' ],
    [ 'lblMyLibrary', 'My Library' ],
    [ 'lblMyPortfolios', 'My Portfolios' ],
    [ 'lblFavoriteArticles', 'Favorite Articles' ],
    [ 'lblFavoriteWebinars', 'Favorite Webinars' ],
    [ 'lblSignOut', 'Sign Out' ],
    [ 'lblSupport', 'Support' ],
    [ 'lblContactUs', 'Contact Us' ],
    [ 'lblContact', 'Contact' ],
    [ 'lblReset', 'App Reset' ],
    [ 'lblPolicies', 'Policies' ],
    [ 'lblPrivacyPolicy', 'Privacy Policy' ],
    [ 'lblRefundPolicy', 'Refund Policy' ],
    [ 'lblSmsPolicy', 'SMS Text Policy' ],
    [ 'lblTermsAndConditions', 'Terms & Conditions' ],
    [ 'lblWhitelistInstructions', 'Whitelist Instructions' ],
    [ 'lblNotifications', 'Notifications' ],
    [ 'lblMarkAllRead', 'Mark all read' ],
    [ 'lblAllCaughtUp', "You're all caught up" ],
    [ 'lblCheckingNotifications', 'Checking for new articles, trade alerts, and webinars…' ],
    [ 'lblNoUnreadNotifications', 'No new articles, trade alerts, or webinars in the last 5 days.' ],
    [ 'lblTurnOffNotifications', 'Turn off notifications' ],
    [ 'lblTurnOnNotifications', 'Turn on notifications' ],
    [ 'lblNotificationsAreOff', 'Notifications are turned off' ],
    [ 'lblNotificationsOffHint', 'Turn them back on to see new articles, trade alerts, and webinars here.' ],
    [ 'lblSocial', 'Social' ],
    [ 'lblFacebook', 'Facebook' ],
    [ 'lblX', 'Twitter' ],
    [ 'lblInstagram', 'Instagram' ],
    [ 'lblYouTube', 'YouTube' ],
    [ 'lblDiscord', 'Discord' ],

    [ 'lblSectorSpotlight', 'Weekly Sector Spotlight' ],
    [ 'lblSectorBreadth', 'Sector Breadth' ],
    [ 'lblMoreDetails', 'More Details' ],

    [ 'lblSectorRsColumnTitle', 'URGENCY / S&P500' ],
    [ 'lblPeerRsColumnTitle', 'URGENCY / Sector' ],
    [ 'lblSecurityMarketRsColumnTitle', `Stock's Strength`  ],
    [ 'lblSectorRsColumnHoverTooltip', 'URGENCY compared to the equally weighted S&P 500' ],
    [ 'lblSectorBpiSignalTitle', 'Long-Term Demand' ],
    [ 'lblSectorBpiSignalHoverTooltip', '???' ],
    [ 'lblSectorBpiColumnTitle', 'Short-Term Demand' ],
    [ 'lblBpiColumnHoverTooltip', '???' ],
    [ 'lblSectorP30SignalTitle', 'Precision Demand' ],
    [ 'lblSectorP30SignalHoverTooltip', '???' ],

    [ 'lblSectorsAllTitle', 'All' ],
    [ 'lblSectorsRelativeStrengthTitle', 'Long-Term / Investors'],
    [ 'lblSectorsBullishPercentIndexTitle', 'Short-Term / Traders' ],
    [ 'lblSectorsP30SignalTitle', 'Precision Demand' ],
    [ 'lblSectorsP30ColumnTitle', 'Ultra Precision Demand' ],
    [ 'lblSectorsEwPercentChgTitle', 'Sector Index Delta (%)' ],

    [ 'lblAvailableServices', 'Available Services' ],
    [ 'lblProducts', 'Products' ],
    [ 'lblAbout', 'About' ],
    [ 'lblSignUp', 'Sign Up' ],
    [ 'lblLogIn', 'Log In' ],
    [ 'lblJoinFree', 'Join Free' ],
    [ 'lblBpiChartTitle', 'Long-Term Demand' ],
    [ 'lblBpiChart', 'BPI' ],
    [ 'lblPercentThirtyChartTitle', 'Precision Demand' ],
    [ 'lblPercentThirtyChart', '%30' ],
    [ 'lblPercentTenChartTitle', 'Micro-Demand' ],
    [ 'lblPercentTenChart', '%10' ],
    [ 'lblSectorBellCurveXColumnInstitutions', 'Institutions Buying the Sector' ],
    [ 'lblSectorBellCurveXColumn', '("BUY NOW"...BPI in Xs)' ],
    [ 'lblSectorBellCurveOColumnInstitutions', 'Institutions Selling the Sector' ],
    [ 'lblSectorBellCurveOColumn', '("WAIT"...BPI in Os)' ],

    [ 'lblSymbol', 'Symbol' ],
    [ 'lblSector', 'Sector' ],
    [ 'lblStockEntryPrice', 'Stock (Entry $)' ],
    [ 'lblOptionsEntryPrice', 'Options (Entry $)' ],
    [ 'lblLastClose', 'Last Close' ],
    [ 'lblStance', 'Stance' ],
    [ 'lblBpiStatus', 'BPI Status' ],
    [ 'lblSectorRS', 'Sector URGENCY' ],
    [ 'lblPeerRS', 'Peer URGENCY' ],
    [ 'lblMarketRS', 'Market URGENCY' ],
    [ 'lblCurrentStockGains', 'Current Stock Gains' ],
    [ 'lblCurrentOptionsGains', 'Current Options Gains' ],
    [ 'lblInitiated', 'Initiated' ],
    [ 'lblLastUpdated', 'Last Updated' ],
    [ 'lblMostRecentCheckPoint', 'Most Recent Checkpoint' ],
    [ 'lblPriceTarget', 'Price Target' ],
    [ 'lblStopLoss', 'Stop Loss' ],
    [ 'lblMonthEndGains', 'M/E Gains' ],
    [ 'lblMaxGains', 'Max Gains' ],
    [ 'lblOptionExpirationMonth', 'Option Expiration Month' ],
    [ 'lblOptionStrike', 'Option Strike' ],
    [ 'lblActions', 'Actions' ],
    [ 'lblExited', 'Exited' ],
    [ 'lblStockExitPrice', 'Stock (Exit $)' ],
    [ 'lblOptionExitPrice', 'Option (Exit $)' ],
    [ 'lblBuyUnder', 'Buy Under' ],
    [ 'lblStockGains', 'Stock P&L' ],
    [ 'lblOptionGains', 'Option P&L' ],
    [ 'lblWeighting', 'Weighting' ],

    [ 'lblBullishLabel', 'BUY NOW' ],
    [ 'lblBearishLabel', 'WAIT' ],

    [ 'lblRsBullishLabel', 'BUY NOW' ],
    [ 'lblRsBearishLabel', 'WAIT' ],
    [ 'lblBpiBullishLabel', 'BUY NOW' ],
    [ 'lblBpiBearishLabel', 'WAIT' ],
    [ 'lblP30BullishLabel', 'BUY NOW' ],
    [ 'lblP30BearishLabel', 'WAIT' ],
    [ 'lblP10BullishLabel', 'BUY NOW' ],
    [ 'lblP10BearishLabel', 'WAIT' ],

    [ 'lblLongTermIndication', 'Long-Term' ],
    [ 'lblIntermediateTermIndication', 'Intermediate-Term' ],
    [ 'lblShortTermIndication', 'Short-Term' ],

    [ 'lblRelativeBullishIndication', 'Above Average' ],
    [ 'lblRelativeBearishIndication', 'Below Average' ]
] );

export function useLabelService() {
    function label( key: string ): string {
        const labelValue = labelMap.get( key );
        if ( !labelValue ) {
            throw new ConfigurationError(
                `The label key '${ key }' is not currently defined. Update the configuration and rebuild.`
            );
        }

        return labelValue!;
    }

    return {
        label
    }
}

export type LabelService = ReturnType< typeof useLabelService >;